import { render, staticRenderFns } from "./TenantsListPage.vue?vue&type=template&id=6e657cf3"
import script from "./TenantsListPage.vue?vue&type=script&lang=js"
export * from "./TenantsListPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports